import script from "./DocListsMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./DocListsMenu.vue?vue&type=script&setup=true&lang=ts"

import "./DocListsMenu.vue?vue&type=style&index=0&id=d68eb508&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d68eb508"]])

export default __exports__